import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { PricingCards } from './PricingCards';
import { SectionHeading } from './SectionHeading';
import { estudioProRows } from '../data/salesData';
export function OfferSection() {
  return <section id="oferta" className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-136" data-mp="ddvhxkufwph7">
      <div className="mx-auto max-w-6xl px-4" data-id="element-137" data-mp="idrl5hvbccvp">
        {/* Launch price / countdown */}
        <div className="mx-auto max-w-2xl rounded-2xl border border-[var(--gold)]/40 bg-[#12140b] p-6 text-center sm:p-8" data-id="element-138" data-mp="mejv6dc0elt1">
          <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-[var(--gold)]" data-id="element-139" data-mp="rey37vdm1vr2">
            ⏰ Precio de lanzamiento
          </p>
          <Countdown data-id="element-140" data-mp="wan6o9sr3wsn" />
          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-[var(--gold-light)]" data-id="element-141" data-mp="2t5jaz56c1xuq">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="2y3ujnckw62bd" />
            Después sube $8.000 ARS. No vuelve.
          </p>
          <div className="mt-6" data-id="element-143" data-mp="12oa6uqljvzh4">
            <div className="mx-auto h-2 max-w-md overflow-hidden rounded-full bg-white/10" data-id="element-144" data-mp="12pl8ajriwv52">
              <div className="h-full w-[68%] rounded-full bg-[var(--gold)]" data-id="element-145" data-mp="xup6irwhiter" />
            </div>
            <p className="mt-2 text-sm text-white/60" data-id="element-146" data-mp="sxyviizjeo07">
              🔴 68% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        <SectionHeading className="mt-16" data-id="element-147" data-mp="1ll31orad98dk">Elegí tu Super Kit</SectionHeading>

        <div className="mt-10" data-id="element-148" data-mp="1gmrp48sosjrn">
          <PricingCards data-id="element-149" data-mp="1gnt4uqkndufp" />
        </div>

        {/* Estudio PRO comparison */}
        <div className="mt-16" data-id="element-150" data-mp="1ckn0xpl0cfce">
          <h3 className="text-center font-serif-display text-2xl font-bold text-[var(--cream)] sm:text-3xl" data-id="element-151" data-mp="1cjv6ii35cnnp">
            ¿Qué agrega Estudio PRO?
          </h3>

          <div className="mt-6 overflow-x-auto" data-id="element-152" data-mp="17kjytezxnrp">
            <table className="w-full min-w-[640px] border-separate border-spacing-0 overflow-hidden rounded-2xl border border-[var(--olive)]/40 text-left text-sm" data-id="element-153" data-mp="146gtiyidaj7">
              <thead data-id="element-154" data-mp="3tvauq5fr3gdq">
                <tr className="bg-[#12140b]" data-id="element-155" data-mp="3trwsqyb0196t">
                  <th className="p-4 font-semibold text-[var(--cream)]" data-id="element-156" data-mp="2o8177cfwy0c">
                    Situación
                  </th>
                  <th className="p-4 font-semibold text-red-400" data-id="element-157" data-mp="3ksjhq1788cjz">
                    ❌ Sin Estudio PRO
                  </th>
                  <th className="p-4 font-semibold text-[var(--olive-light)]" data-id="element-158" data-mp="3owzkhtljn3uz">
                    ✅ Con Estudio PRO
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-159" data-mp="3fvt19crifey1">
                {estudioProRows.map((row, i) => <tr key={row.situation} className={i % 2 === 0 ? 'bg-[#0d0f08]' : 'bg-[#0a0b06]'} data-id="element-160" data-mp="316dee7v3ntnm" data-mpi={i}>
                    <td className="border-t border-white/5 p-4 font-medium text-[var(--cream)]" data-id="element-161" data-mp="2s4nlexlkkmnq">
                      {row.situation}
                    </td>
                    <td className="border-t border-white/5 p-4 text-white/55" data-id="element-162" data-mp="2x37bna774klw">
                      {row.without}
                    </td>
                    <td className="border-t border-white/5 p-4 text-white/80" data-id="element-163" data-mp="28iu79plmjjjm">
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}